/*Import Estilo*/
import './index.scss';
import '../../css/global.css';
import '../../css/normalize.css';

/*Import Bibliotecas*/
import { useNavigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';

/*Import Componentes*/
import Cabecalho from '../../components/Cabecalho';
import Rodape from '../../components/Rodape';
import CookieAceite from '../../components/CookieAceite';

/*Import Requisição API*/
import api from '../../api';

export default function ConfirmacaoEmailCodigo() {

    /* Variaveis para enviar ao banco de dados */

    const [codigo, setCodigo] = useState(Array(6).fill(''));

    /* Outros */

    const navigate = useNavigate();
    const [cooldown, setCooldown] = useState(60);
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const { email } = location.state || {};

    /* Caixas de dialogo */

    const [texto, setTexto] = useState('');
    const caixaDeDialogo = useRef(null);
    const CaixaDeDialogoSucesso = useRef(null);

    useEffect(() => {
        caixaDeDialogo.current = document.getElementById("CaixaDeDialogo");
    }, []);

    const fecharModal = () => {
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.close();
        }
    };

    const mostrarModal = () => {
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.showModal();
        }
    };

    useEffect(() => {
        CaixaDeDialogoSucesso.current = document.getElementById("CaixaDeDialogoSucesso");
    }, []);

    const mostrarModalSucesso = () => {
        if (CaixaDeDialogoSucesso.current) {
            CaixaDeDialogoSucesso.current.showModal();
        }
    };

    /* Fim caixas de Dialogo */

    const formatarTempo = (segundos) => {
        const minutos = Math.floor(segundos / 60).toString().padStart(2, '0');
        const segundosRestantes = (segundos % 60).toString().padStart(2, '0');
        return `${minutos}:${segundosRestantes}`;
    };

    const reenviarCodigo = async (e) => {
        e.preventDefault();

        try {
            await api.post('/enviar-codigo-confirmacao-email', { email });
            setTexto('Código de verificação enviado com sucesso! Verifique sua caixa de entrada ou (spam/lixeira)');
            mostrarModal();
            setCooldown(60);
        } catch (error) {
            console.error('Erro ao reenviar código:', error);
            setTexto('Erro ao enviar código. Tente novamente.');
            mostrarModal();
        }
    };

    useEffect(() => {
        if (cooldown > 0) {
            const intervalo = setInterval(() => {
                setCooldown((prevCooldown) => prevCooldown - 1);
            }, 1000);
            return () => clearInterval(intervalo);
        }
    }, [cooldown]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const codigoCompleto = codigo.join('');

        setLoading(true);
        try {
            const response = await api.post('/verificacao-email', {
                email,
                codigo: codigoCompleto,
            });

            if (response.data.success) {
                setTexto('Cadastro concluído com sucesso!');
                mostrarModalSucesso();
                setTimeout(() => {
                    navigate('/login');
                }, 3000);
            }
        } catch (error) {
            if (error.response && error.response.status === 400) {
                setTexto('O código inserido está incorreto. Confira o código enviado ao seu e-mail e tente novamente.');
            } else {
                setTexto('Ocorreu um erro ao validar o código. Por favor, tente novamente.');
            }
            mostrarModal();
            console.error('Erro ao validar o código:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e, index) => {
        const { value } = e.target;

        if (value.length > 1) {
            handlePastedData(value);
        } else if (/^\d$/.test(value) || value === '') {
            const newCodigo = [...codigo];
            newCodigo[index] = value;
            setCodigo(newCodigo);

            if (value && index < 5) {
                document.getElementById(`input-${index + 1}`).focus();
            }
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text');
        const digits = pastedData.split('').slice(0, 6);

        const newCodigo = [...codigo];

        for (let i = 0; i < digits.length; i++) {
            if (i < newCodigo.length) {
                newCodigo[i] = digits[i];
            }
        }

        setCodigo(newCodigo);
    };

    const handlePastedData = (value) => {
        const newCodigo = [...codigo];
        const pastedDigits = value.split('').filter(char => /^\d$/.test(char)).slice(0, 6);

        for (let i = 0; i < pastedDigits.length; i++) {
            if (i < newCodigo.length) {
                newCodigo[i] = pastedDigits[i];
            }
        }

        setCodigo(newCodigo);
        document.getElementById(`input-${Math.min(pastedDigits.length - 1, 5)}`).focus();
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            if (codigo[index] === "" && index > 0) {
                const newCodigo = [...codigo];
                newCodigo[index - 1] = "";
                setCodigo(newCodigo);
                document.getElementById(`input-${index - 1}`).focus();
            } else if (index > 0) {
                const newCodigo = [...codigo];
                newCodigo[index] = "";
                setCodigo(newCodigo);
            }
        }
    };

    return (
        <section className='containerPrincipalInserirCodigo'>
            <Cabecalho />
            <CookieAceite />
            <dialog id="CaixaDeDialogo">
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <p>{texto}</p>
                        <button onClick={fecharModal}>
                            Ok
                        </button>
                    </div>
                </div>
            </dialog>

            <dialog id="CaixaDeDialogoSucesso">
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24"><g fill="none" stroke="#4AC204" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path stroke-dasharray="64" stroke-dashoffset="64" d="M3 12c0 -4.97 4.03 -9 9 -9c4.97 0 9 4.03 9 9c0 4.97 -4.03 9 -9 9c-4.97 0 -9 -4.03 -9 -9Z"><animate fill="freeze" attributeName="stroke-dashoffset" dur="0.6s" values="64;0" /></path><path stroke-dasharray="14" stroke-dashoffset="14" d="M8 12l3 3l5 -5"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.6s" dur="0.2s" values="14;0" /></path></g></svg>
                        <p>{texto}</p>
                    </div>
                </div>
            </dialog>

            <main>
                <section className='conteudoMainInserirCodigo'>
                    {loading ? (
                        <div className="loading">
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><path fill="#fff" d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity="0.25" /><path fill="#fff" d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"><animateTransform attributeName="transform" dur="0.75s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12" /></path></svg>
                        </div>
                    ) : (
                        <>
                            <ul class="iconResetPassword">
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                            </ul>

                            <div className='box-InseirCodigo'>
                                <h1>Insira o código</h1>
                                <h2>Enviado em seu e-mail</h2>
                                <div className='container-EmailOuEditar'>
                                    <h3>{email}</h3>
                                </div>
                                <form>
                                    <div className="code-inputs-container">
                                        {Array(6).fill().map((_, index) => (
                                            <input
                                                key={index}
                                                id={`input-${index}`}
                                                type="text"
                                                maxLength="1"
                                                value={codigo[index] || ""}
                                                onChange={(e) => handleInputChange(e, index)}
                                                onKeyDown={(e) => handleKeyDown(e, index)}
                                                onPaste={(e) => handlePaste(e, index)}
                                                className="digit-input"
                                            />
                                        ))}
                                    </div>
                                    <button className='bnt-EnviarCodigo' onClick={handleSubmit}>Validar Código</button>
                                    <button className={`bnt-ReEnviarCodigo ${cooldown > 0 ? 'bloqueado' : ''}`}
                                        onClick={reenviarCodigo}
                                        disabled={cooldown > 0}
                                    >
                                        {cooldown > 0 ? `Reenviar em ${formatarTempo(cooldown)}` : 'Reenviar Código'}
                                    </button>
                                </form>
                            </div>
                        </>
                    )}
                </section>
            </main>
            <Rodape />
        </section>
    );
}
